export const GIF_URL =
    'https://fiverr-res.cloudinary.com/video/upload/v1/video-attachments/generic_asset/asset/94c2e72f245919f5da48e83be69fc2bc-1750788016771/-16667090096898424401_register_to_shopify';
export const SHOPIFY_URL = 'http://shopify.pxf.io/c/4931442/1061744/13624?subId1=BuildYourStore&subId2=Fiverr';
